<ion-header
  [translucent]="false"
  [collapse]="collapse()"
  [class.no-padding-right]="noPaddingRight()"
  [class.transparent]="transparent()"
  [style.min-height]="minHeight()"
>
  <ng-content></ng-content>
</ion-header>
